import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from 'src/app/services/modal.service';
import { RumiService } from 'src/app/services/rumi.service';

@Component({
  selector: 'app-apreciacio-gravetat',
  templateUrl: './apreciacio-gravetat.component.html'
})
export class ApreciacioGravetatComponent implements OnInit {
  
  public get conjuntsSeleccionats(){
    return this.rumiService.conjuntsSeleccionats;
  }

  public get gravetats(){
    return this.rumiService.gravetats;
  }

  constructor(
    public translate: TranslateService,
    private router: Router,
    private rumiService: RumiService,
    public modal: ModalService
  ) { }

  ngOnInit() {
    this.rumiService.pestanyaActiva = this.router.url;    
  }

  goToNextStep() {
    if(this.validar()){
      this.rumiService.conjuntsSeleccionats.forEach(conjunt => {
        var gravetat = this.gravetats.find(gravetat=>gravetat.id == conjunt.idGravetat);
        if(gravetat != null){
          conjunt.descripcioGravetat = gravetat.descripcio.replace("Gravetat ","");
        }
      });
      this.router.navigate(['simulacio','valoracions-finals']);
    }else{      
      this.modal.open('errors');
    }
  }

  goToPrevStep() {
    this.router.navigate(['simulacio','questionari-observacions']);
  }

	navigate(url: String){
	  this.router.navigate([url]);
	}
  
  validar() {
    var resultat = true;
    this.rumiService.conjuntsSeleccionats.forEach(conjunt => {
      if(conjunt.observacions != null && conjunt.observacions.length> 0 && (conjunt.idGravetat == null || conjunt.idGravetat == 0)){
        resultat = false;
      }
    });
    return resultat;
  }

}
